import React from "react";
import { Link } from "react-router-dom";
import "./index.css";
import logo from "../assests/viyash 1.svg";

// Import new footer icons
import linkedinIcon from "../assests/FooterImages/footer-linkdin-icon.svg";
import twitterIcon from "../assests/FooterImages/footer-twitter-icon.svg";
import facebookIcon from "../assests/FooterImages/footer-facebook-icon.svg";
import youtubeIcon from "../assests/FooterImages/footer-youtube-icon.svg";
import locationIcon from "../assests/FooterImages/footer-location-icon.svg";
import phoneIcon from "../assests/FooterImages/footer-phone-icon.svg";
import emailIcon from "../assests/FooterImages/footer-email-icon.svg";

const Footer = () => {

    const navigationLinks = [
        { label: "Home", href: "/" },
        { label: "About Viyash", href: "/about" },
        { label: "API", href: "/api" },
        { label: "Human Health", href: "/human-health" },
        { label: "Animal Health", href: "/animal-health" },
        { label: "CDMO & Capabilities", href: "/cdmo" },
        { label: "Manufacturing & Quality", href: "/manufacturing-quality" },
    ];

    const quickLinks = [
        { label: "Investors", href: "/investors" },
        { label: "Sustainability & CSR", href: "/sustainability" },
        { label: "Careers", href: "/careers" },
        { label: "Contact", href: "/contact" },
    ];

    const socialIcons = [
        { label: "LinkedIn", icon: linkedinIcon },
        { label: "Twitter", icon: twitterIcon },
        { label: "Facebook", icon: facebookIcon },
        { label: "YouTube", icon: youtubeIcon },
    ];

    return (
        <footer className="site-footer">

            <div className="footer-grid">

                {/* Brand */}
                <div className="footer-brand">

                    <div className="footer-logo">
                        <img src={logo} alt="Viyash" className="footer-logo-img" />
                    </div>

                    <div className="footer-descriptions">
                        <p className="footer-desc">Global leader in pharmaceutical innovation</p>
                        <p className="footer-desc">Human health, animal health, and CDMO excellence</p>
                    </div>

                    <div className="footer-contacts">
                        <div className="footer-contact">
                            <img src={locationIcon} alt="Location" className="footer-contact-icon" />
                            <div>
                                <p>Madhapur, Hyderabad</p>
                                <p>Rangareddi, TG 500081, India</p>
                            </div>
                        </div>

                        <div className="footer-contact">
                            <img src={phoneIcon} alt="Phone" className="footer-contact-icon" />
                            <span>+91 40 2363 5000</span>
                        </div>

                        <div className="footer-contact">
                            <img src={emailIcon} alt="Email" className="footer-contact-icon" />
                            <span>info@viyash.com</span>
                        </div>
                    </div>

                </div>

                {/* Navigation */}
                <div>
                    <h4 className="footer-title">Navigation</h4>

                    <div className="footer-links-grid">
                        {navigationLinks.map((link) => (
                            <Link key={link.label} to={link.href} className="footer-link">
                                {link.label}
                            </Link>
                        ))}
                    </div>
                </div>

                {/* Quick Links */}
                <div>
                    <h4 className="footer-title">Quick Links</h4>
                    <div className="footer-quick-links">
                        {quickLinks.map((link) => (
                            <Link key={link.label} to={link.href} className="footer-link">
                                {link.label}
                            </Link>
                        ))}
                    </div>
                </div>

            </div>

            <div className="footer-divider"></div>

            {/* Bottom */}
            <div className="footer-bottom">

                <p className="footer-copy">
                    &copy; 2026 Viyash Scientific Ltd. All Rights Reserved.
                </p>

                {/* Social Icons */}
                <div className="footer-social">
                    {socialIcons.map((social) => (
                        <a key={social.label} href="#" className="social-icon">
                            <img src={social.icon} alt={social.label} className="social-icon-img" />
                        </a>
                    ))}
                </div>

                <div className="footer-legal">
                    <Link to="/policies">Privacy Policy</Link>
                    <Link to="/terms-of-use">Terms of Use</Link>
                </div>

            </div>

        </footer>
    );
};

export default Footer;